import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLockOpen, faBell } from "@fortawesome/free-solid-svg-icons";
import React, { useCallback, useContext, useState } from "react";
import { Nav, NavLink, Row, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Col } from "reactstrap";
import { NavItem } from "reactstrap";
import { BankUserContext } from "../../bankUserContext";
import AdminSettings from "../../pages/AdminSettings";
// import RolesAuthentication from "../../Utils/RolesUtlis";
import ChangePasswordUser from "../AdminSettings/ChangePasswordUser";
import NotificationSettings from "./NotificationSettings";
import AdminPricingSettings from "./AdminPricingSettings/AdminPricingSettings";
import { ReactComponent as DollarIcon } from "../../images/productsIcons/dollarIcon.svg";

const Settings = () => {
  // const roles = new RolesAuthentication();
  const bankUserContext = useContext(BankUserContext);
  const [activeKey, setActiveKey] = useState<string | null>();


  const renderTabs = useCallback(()=>{
   return( <Tab.Container id="left-tabs-example" defaultActiveKey="Settings" onSelect={(e:string | null)=>setActiveKey(e)}>
    <Col sm={2} className="sideBar">
      <Nav
        variant="pills"
        id="toDoListNav"
        className="flex-column mb-3"
      >
        <Nav.Item>
          <Nav.Link eventKey="Settings">
            <FontAwesomeIcon icon={faLockOpen} />
            &nbsp; Change Password
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="Notifications">
            <FontAwesomeIcon icon={faBell} />
            &nbsp; Notifications
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="AdminPricingSettings" >
            <div className="outerDiv">
              <div className="innerDiv">
              <DollarIcon className="dollarIcon"/>
              </div>
            </div>
            &nbsp; Admin Pricing Settings
          </Nav.Link>
        </Nav.Item>
        {/* {roles.IsAdmin(bankUserContext?.bankuserDetails?.roles) ? (
          <Nav.Item>
            <Nav.Link eventKey="AdminSettings">
              Admin Settings
            </Nav.Link>
          </Nav.Item>
        ) : (
          " "
        )} */}
        {/* <Nav.Item>
          <Nav.Link eventKey="AiBotSettings">
            AI Bot Settings
          </Nav.Link>
        </Nav.Item> */}
      </Nav>
    </Col>
    <Col sm={10} className="changepassword-screen">
      <Tab.Content>
        <Tab.Pane eventKey="Settings">
          <ChangePasswordUser />
        </Tab.Pane>
        <Tab.Pane className="notifications" eventKey="Notifications">
          <NotificationSettings appNotifiaction={true} />
        </Tab.Pane>

        <Tab.Pane eventKey="AdminSettings">
          <AdminSettings />
        </Tab.Pane>

        <Tab.Pane eventKey="AdminPricingSettings">
          <AdminPricingSettings  tabName={activeKey}/>
        </Tab.Pane>

        <Tab.Pane eventKey="AiBotSettings"></Tab.Pane>
      </Tab.Content>
    </Col>
  </Tab.Container>)
  },[activeKey])

  return (
    <>
      <div className="settingsPage">
        <div className="container-fluid settingsHeader">
          <Row>
            <span className="headerName">Settings and Preferences</span>
          </Row>
        </div>
        <div className="sidebarSettings container-fluid">
          <Row>
           {renderTabs()}
          </Row>
        </div>
      </div>
    </>
  );
};
export default Settings;
